<template>
  <section class="flex align-middle justify-center sm:py-40">
    <Card class="w-448 max-w-screen p-24">
      <h1 class="text-h1 mb-16">Upgrade request sent</h1>
      <p class="pb-16 text-body text-grey-body">
        Our Customer Success team will validate your request. You will receive a confirmation email in 1-2 business days.
      </p>
      <Button
        id="continue-registration-btn"
        class="w-full"
        variant="primary"
        value="Continue signing up"
        size="medium"
        @click="continueRegistration"
      />
    </Card>
  </section>
</template>

<script lang="ts">
import Card from '@/components/card/Card.vue';
import Button from '@/components/button/Button.vue';

export default {
  name: 'UpgradeRequestSent',
  components: {
    Card,
    Button,
  },
  methods: {
    continueRegistration() {
      this.$router.push({ name: 'registration-care-type' });
    },
  },
};
</script>
